import React, { useContext, useEffect } from "react";
import { ErrorMessage, Field, useFormikContext } from "formik";
import { CartContext } from "../../contexts/CartContext";
import { ReactComponent as SearchIcon } from "../../icons/searchIcon.svg";
import { stateOptions } from "../../utils/stateOptions";
import { countries } from "../../utils/countriesData";
import { ReactComponent as InfoIcon } from "../../icons/infoIcon.svg";
import Tooltip from "../shared/Tooltip";
import { getTaxRate } from "../../utils/taxRate";

export const ContactInfo = (props) => {
  const { setTaxRate } = useContext(CartContext);
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (values.state) {
      const taxRate = getTaxRate(values.state);
      setTaxRate(taxRate);
    }
  }, [values.state, setTaxRate]);

  const handleStateChange = (e) => {
    const state = e.target.value;
    setFieldValue("state", state);
    const taxRate = getTaxRate(state);
    console.log("ContactInfo handleStateChange Tax rate: ", taxRate); // "Tax rate: 0.07
    setTaxRate(taxRate);
  };

  return (
    <>
      <div>
        <div className="mb-4 w-full relative">
          <div className="relative mt-1 block">
            <label htmlFor="country" className="relative">
              <span className="text-xs absolute text-[#707070] top-[-12px] left-[16px]">
                Country/Region
              </span>
            </label>
            <Field
              as="select"
              id="country"
              type="text"
              name="country"
              className="w-full px-3 pt-6 pb-2 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
            >
              {countries.map((country) => (
                <option
                  disabled={country.disabled}
                  key={country.value}
                  value={country.value}
                >
                  {country.label}
                </option>
              ))}
            </Field>
          </div>
        </div>
        <div className="mb-4 flex flex-col sm:flex-row gap gap-4 w-full">
          <div className="w-full">
            <Field
              id="firstName"
              type="text"
              name="firstName"
              Placeholder="First name"
              className="mt-1 block w-full px-3 py-4 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
            />
            <ErrorMessage
              name="firstName"
              component="div"
              className="text-red-500 text-xs mt-1"
            />
          </div>

          <div className="w-full">
            <Field
              id="lastName"
              type="text"
              name="lastName"
              Placeholder="Last name"
              className="mt-1 block w-full px-3 py-4 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
            />
            <ErrorMessage
              name="lastName"
              component="div"
              className="text-red-500 text-xs mt-1"
            />
          </div>
        </div>

        <div className="mb-4 w-full ">
          <div className="relative">
            <Field
              id="address"
              type="text"
              name="address"
              Placeholder="Address"
              className="mt-1 block w-full pl-3 pr-8 py-4 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
            />

            <div className="text-[#707070] stroke-current absolute inset-y-0 right-0 flex items-center justify-center pr-3 pointer-events-none z-10 top-[50%] transform -translate-y-1/2 w-8 h-8">
              <SearchIcon />
            </div>
          </div>
          <ErrorMessage
            name="address"
            component="div"
            className="text-red-500 text-xs mt-1"
          />
        </div>

        <div className="mb-4 w-full">
          <Field
            id="apartment"
            type="text"
            name="apartment"
            Placeholder="Apartment, suite, etc. (optional)"
            className="mt-1 block w-full px-3 py-4 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
          />
        </div>

        <div className="mb-4 flex flex-col sm:flex-row gap-4 w-full">
          <div className="w-full">
            <Field
              id="city"
              type="text"
              name="city"
              Placeholder="City"
              className="mt-1 block w-full px-3 py-4 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
            />
            <ErrorMessage
              name="city"
              component="div"
              className="text-red-500 text-xs mt-1"
            />
          </div>

          <div className="w-full">
            <div className="relative mt-1 block">
              <label htmlFor="state" className="relative">
                <span className="text-xs absolute text-[#707070] top-[-12px] left-[16px]">
                  State
                </span>
              </label>
              <Field
                as="select"
                id="state"
                type="text"
                name="state"
                Placeholder="Last name"
                className="w-full px-3 pt-6 pb-2 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
                onChange={handleStateChange}
              >
                {stateOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    data-alternate-values={JSON.stringify(option.alternate)}
                  >
                    {option.label}
                  </option>
                ))}
              </Field>
            </div>
          </div>

          <div className="mb-4 w-full">
            <Field
              id="zipCode"
              type="text"
              name="zipCode"
              Placeholder="Zip Code"
              className="mt-1 block w-full px-3 py-4 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
            />
            <ErrorMessage
              name="zipCode"
              component="div"
              className="text-red-500 text-xs mt-1"
            />
          </div>
        </div>

        <div className="mb-4 w-full">
          <div className="relative">
            <Field
              id="phone"
              type="tel"
              name="phone"
              Placeholder="Phone"
              className="mt-1 block w-full pl-3 pr-10 py-4 border border-[#dedede] rounded-md shadow-sm focus:outline focus:ring-black focus:border-black sm:text-sm"
            />

            <span className="text-[#707070] stroke-current absolute z-10 right-0 top-[50%] transform -translate-y-1/2 pr-3 cursor-pointer">
              <Tooltip
                content={
                  <div className="w-36 text-xs text-center py-2 leading-relaxed">
                    In case we need to contact you about your order
                  </div>
                }
              >
                <InfoIcon fill="none" height="18px" width="18px" />
              </Tooltip>
            </span>
          </div>
          <ErrorMessage
            name="phone"
            component="div"
            className="text-red-500 text-xs mt-1"
          />
        </div>
      </div>
    </>
  );
};
